import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

import { partialWithDefault } from 'app/common/CommonUtils';

import * as Account from './Account';

export const type = 'member';

export const api = buildEntityApi(type, (path, getState) => {
  const currentAccountId = Account.selectors.all.currentAccountId(getState());
  return `/api/v3/accounts/${currentAccountId}/members/${path}`;
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.all.shouldLoad = sel.all.isUnloaded;
  sel.email = partialWithDefault(sel.dataItem, ['email'], '');
  sel.id = partialWithDefault(sel.dataItem, ['id'], '');
  sel.name = partialWithDefault(sel.dataItem, ['name'], '');
  sel.normalizedName = entity => {
    // we have to trim the name first since it will come in as ' ' when it is empty
    return (sel.name(entity).trim() || sel.email(entity)).trim();
  };
});

export const actions = buildEntityActions(
  type,
  selectors,
  api,
  entityActions => {
    entityActions.loadCollectionIfTeamAccount = (...args) => (
      dispatch,
      getState
    ) => {
      const currentAccount = Account.selectors.all.currentAccount(getState());
      return Account.selectors.isOrWasTeam(currentAccount)
        ? dispatch(entityActions.loadCollection(...args))
        : Promise.resolve();
    };
  }
);
